import { mount } from 'svelte';
import './app.css';
import App from './App.svelte';
import { store } from './lib/store.svelte.ts';
import { unlockAudio } from './lib/feedback.ts';

// Light only, by design: there is no theme switch and nothing reads prefers-color-scheme.
void store.boot();

// The scan cue needs an audio context, and a browser only grants one off a user gesture.
// Taking the first touch of the session means the first scan already beeps.
unlockAudio();

export default mount(App, { target: document.getElementById('app')! });
